module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.recallDisplay) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold",
      "font-size": "large",
      "padding": "0px"
    }
  }, [_c('span', {
    staticClass: "pull-left"
  }, [_vm._v("# " + _vm._s(_vm.checkNum))]), _vm._v(" "), (_vm.time) ? _c('span', {
    staticClass: "pull-right",
    style: ('font-size: smaller; color: ' + _vm.timeColour)
  }, [_vm._v(_vm._s(_vm.time))]) : _vm._e(), _vm._v(" "), _c('br', {
    attrs: {
      "clear": "all"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "5px 0px 0px 0px",
      "font-size": "medium"
    }
  }, [_vm._v(_vm._s(_vm.displayHeader(_vm.revenueType, _vm.lastName)))]), _vm._v(" "), (_vm.id) ? _c('div', {
    staticStyle: {
      "border": "solid green 1px",
      "padding": "5px 10px",
      "margin": "3px 0px 0px 0px",
      "text-align": "left",
      "font-size": "smaller"
    }
  }, [_vm._v("\r\n      " + _vm._s(_vm.$t('name')) + ":"), _c('br'), _vm._v(_vm._s(' ' + _vm.id) + "\r\n    ")]) : _vm._e()]) : _c('div', {
    staticStyle: {
      "text-align": "center",
      "font-weight": "bold",
      "font-size": "large"
    }
  }, [_c('span', {
    staticStyle: {
      "float": "left",
      "margin-right": "20px"
    }
  }, [_vm._v("# " + _vm._s(_vm.checkNum) + "\r\n      "), (_vm.id) ? _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v(_vm._s(_vm.id))]) : _vm._e()]), _vm._v(" "), (_vm.time) ? _c('span', {
    style: ('float: right; color: ' + _vm.timeColour)
  }, [_vm._v(" " + _vm._s(_vm.time))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "5px 2px 0px 2px"
    }
  }, [_vm._v(_vm._s(_vm.displayHeader(_vm.revenueType, _vm.lastName)))]), _vm._v(" "), (_vm.postPay && !_vm.closedDate) ? _c('div', {
    staticStyle: {
      "margin": "3px 0px -10px 0px"
    }
  }, [(!_vm.closedDate) ? _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("** NOT PAID **")]) : _vm._e()]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-44b4145e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrderHeader.vue
// module id = 527
// module chunks = 2